export default "__VITE_ASSET__DA0SPOHZ__"